import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core';

export const themeOptions = createMuiTheme({
  palette: {
    // Main
    primary: {
      main: '#f74f00',
    },
    secondary: {
      main: '#673AB7',
      dark: '#512DA8',
    },
    // Status
    error: {
      main: '#F44336',
      dark: '#D32F2F',
    },
    warning: {
      main: '#FF9800',
      dark: '#F57C00',
    },
    info: {
      main: '#1976D2',
      dark: '#1565C0',
    },
    success: {
      main: '#4CAF50',
      dark: '#388E3C',
    },
    // General
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#424242',
      hint: '#9E9E9E',
      disabled: '#BDBDBD',
    },
  },
  typography: {
    fontFamily: ['Figtree'].join(','),
  },
});

export default themeOptions;
